export const domain = process.env.REACT_APP_API_URL
  || (process.env.NODE_ENV === 'development' ? 'http://localhost:5001/' : '/');

export const API_ROOT = `${domain}api`;

export const setAuthHeader = (
    token = sessionStorage.getItem('jwtToken') || sessionStorage.getItem('jwtTokenClient')
) => {
    return { 'Authorization': `Bearer ${token}` };
};
